import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appIndeterminate]',
    standalone: false,
})
export class IndeterminateDirective {
    @Input() set appIndeterminate (value: boolean) {
        this.renderer.setProperty(this.el.nativeElement, 'indeterminate', !!value);
    }

    constructor (private el: ElementRef, private renderer: Renderer2) {}
}
